module.exports = __webpack_public_path__ + "img/systemnotify.16777a80.gif";